// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
//
import App from './App'
import router from './routes'
import axios from 'axios'
//
import filter from './assets/js/filter'
const install = (Vue) => {
	if(install.installed) return;
	Object.defineProperty(Vue.prototype, '$http', {
		get() {
			return axios
		}
	})
};
/*vuex*/
Vue.use(Vuex)
const store = new Vuex.Store({
	state: {
		bcArray: []
	},
	mutations: {
		getbcArray: (state, route) => {
			state.bcArray = [...route]
		}
	}
})
/* eslint-disable no-new */
router.afterEach(route => {
	let a = (route.path.split('/').fill('home', 0, 1))
	let b = []
	if(a.length > 0) {
		a.forEach((item, i) => {
			b.push({
				name: item,
				active: (i + 1) == a.length ? true : ""
			})
		})
	} else {
		b = []
	}
	store.commit('getbcArray', b)
})
//
/*全局过滤器*/
Vue.filter('goodTime', v => {
	let now = new Date().getTime(),
		oldTime = new Date(v).getTime(),
		difference = now - oldTime,
		result = '',
		minute = 1000 * 60,
		hour = minute * 60,
		day = hour * 24,
		halfamonth = day * 15,
		month = day * 30,
		year = month * 12,
		_year = difference / year,
		_month = difference / month,
		_week = difference / (7 * day),
		_day = difference / day,
		_hour = difference / hour,
		_min = difference / minute;
	if(_year >= 1) {
		result = "发表于 " + ~~(_year) + " 年前"
	} else if(_month >= 1) {
		result = "发表于 " + ~~(_month) + " 个月前"
	} else if(_week >= 1) {
		result = "发表于 " + ~~(_week) + " 周前"
	} else if(_day >= 1) {
		result = "发表于 " + ~~(_day) + " 天前"
	} else if(_hour >= 1) {
		result = "发表于 " + ~~(_hour) + " 个小时前"
	} else if(_min >= 1) {
		result = "发表于 " + ~~(_min) + " 分钟前"
	} else result = "刚刚";
	return result;
})
//

new Vue({
	el: '#app',
	store,
	template: '<App/>',
	components: { App },
	router
});
//



// WEBPACK FOOTER //
// ./src/main.js